import { uppercaseMarketRegion } from '../../../common/utilities';
import { getProductCatalogueApiConfig } from '../config/actions';
/**
 * @internal
 */
export var getFetchSFCCSearchUrl = function () {
    var _a = getProductCatalogueApiConfig(), sfccSearchUrl = _a.sfccSearchUrl, sfccLocale = _a.sfccLocale;
    return sfccSearchUrl + "/" + getFetchSFCCSearchRelativeUrl(sfccLocale);
};
/**
 * @internal
 */
export var getFetchSFCCSearchRelativeUrl = function (locale) {
    return uppercaseMarketRegion(locale || '', '_') + "/" + "ProductSearch-Auth" /* ProductSearch */;
};
